import angular from 'angular';

class UnknownBatchRefModalCtrl {
    /*@ngInject*/
    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        let vm = this;

        vm.includes = {
            errorMessages: require('../../../app/layouts/error-messages.html')
        };

        vm.nbSelected = vm.resolve.nbSelected;
        vm.ok = function() {
            if (vm.$scope.form.$valid) {
                vm.modalInstance.close(vm.$scope.motif);
            }
        };

        vm.cancel = function() {
            vm.modalInstance.dismiss('cancel');
        };
    }
}

angular.module('indexfile').component('unknownBatchRefModal', {
    templateUrl: require('./unknown-batchref-confirm.html'),
    controller: UnknownBatchRefModalCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<'
    }
});
